import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext";
import Grid from "modules/common/components/Grid";
import { useMemo, useState } from "react";
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import { Table, Filter, Pagination } from "../../common";
import type { AirlineRankingTableProps } from "./AirlineRankingTable.d";
import SelectDate from "./SelectDate";

const { Box, Flex, Heading, Stack } = Chakra;

const AirlineRankingTable = ({ columns, rows: initilaRows, heading }: AirlineRankingTableProps) => {
  const [rows, setRows] = useState(initilaRows);
  const memoColumns = useMemo(() => columns, [columns]);
  const memoRows = useMemo(() => rows, [rows]);
  const translations = useTranslations();

  const {
    getTableProps,
    getTableBodyProps,
    page,
    nextPage,
    previousPage,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    headerGroups,
    gotoPage,
    state: { globalFilter, pageIndex },
    setGlobalFilter,
  } = useTable(
    {
      columns: memoColumns,
      data: memoRows,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <Box bg="greyscale.300" py={14}>
      <Grid mb={0}>
        <Box gridColumn={{ base: "span 1", md: "span 12" }}>
          <Flex
            flexDir={{ base: "column", md: "row" }}
            justify="space-between"
            align={{ base: "flex-start", md: "center" }}
          >
            <Heading variant="h3" as="h3">
              {translations(heading)}
            </Heading>
            <Stack
              direction={{ base: "column", md: "row" }}
              spacing={4}
              pt={{ base: 4, md: 0 }}
              justify={{ base: "flex-start", md: "center" }}
              w={{ base: "full", md: "auto" }}
            >
              <SelectDate updateTableContent={setRows} />
              <Filter
                filter={globalFilter}
                setFilter={setGlobalFilter}
                placeholder={translations("search_for_airline")}
              />
            </Stack>
          </Flex>
          <Table
            rows={page}
            getTableProps={getTableProps}
            headerGroups={headerGroups}
            getTableBodyProps={getTableBodyProps}
            prepareRow={prepareRow}
          />
          {pageOptions.length ? (
            <Pagination
              previousPage={previousPage}
              canPreviousPage={canPreviousPage}
              pages={pageOptions.length}
              nextPage={nextPage}
              currentPage={pageIndex + 1}
              canNextPage={canNextPage}
              gotoPage={gotoPage}
            />
          ) : (
            <Box textAlign="center">-</Box>
          )}
        </Box>
      </Grid>
    </Box>
  );
};

export default AirlineRankingTable;
